import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import SRList from "../component/List";
import AkkhorLayout from "../layout/akkhor";
import { useSelector } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { isSeatRealtimeEvent } from "./realtime";

// Quản lý địa điểm đặt chỗ ngồi (dành cho quản trị phòng)
export default function DanhSachDiaDiem() {
    const { saveRealTimeData, datasocket } = useSelector((state) => state.save);
    const [refresh, setRefresh] = useState(false);
    const seatSocketRef = useRef(null);

    useEffect(function () {
        if (isSeatRealtimeEvent(saveRealTimeData) || isSeatRealtimeEvent(datasocket)) {
            setRefresh(prev => !prev);
        }
    }, [saveRealTimeData, datasocket]);

    useEffect(function () {
        let closed = false;
        const connectSeatSocket = () => {
            const ws = new WebSocket('wss://socket.bhsgroup.vn');
            seatSocketRef.current = ws;
            ws.onmessage = (evt) => {
                try {
                    const data = jwtDecode(evt.data);
                    if (data && data.channel === 'bhs_socket' && isSeatRealtimeEvent(data)) {
                        setRefresh(prev => !prev);
                    }
                } catch (e) { /* ignore malformed socket payload */ }
            };
            ws.onclose = () => {
                if (!closed) setTimeout(connectSeatSocket, 1000);
            };
        };
        connectSeatSocket();
        return () => {
            closed = true;
            if (seatSocketRef.current) seatSocketRef.current.close();
        };
    }, []);

    const columns = [
        { name: "id", label: "ID" },
        { name: "title", label: "Tên địa điểm" },
        { name: "code", label: "Mã địa điểm" },
        { name: "address", label: "Địa chỉ" },
        {
            name: "activation_minutes", label: "Hạn kích hoạt (phút)",
            options: { filter: false, sort: true },
        },
        {
            name: "status", label: "Trạng thái",
            options: {
                filter: false, sort: true,
                customBodyRender: (value) => {
                    if (value == 1) return <span className="text-success">Đang hoạt động</span>;
                    return <span className="text-danger">Ngừng hoạt động</span>;
                },
            },
        },
    ];

    return (
        <AkkhorLayout idrole="quan-tri-cho-ngoi">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li>Quản lý địa điểm đặt chỗ</li>
                </ul>
            </div>
            <SRList
                name="seat_locations"
                idrole="quan-tri-cho-ngoi"
                linkaction="dia-diem-cho-ngoi"
                params={''}
                title=""
                defaultLimit={20}
                serverSide={true}
                refresh={refresh}
                columns={columns}
            />
        </AkkhorLayout>
    );
}
